/**
 * PM List watchers
 * @module services/pm-list/watchers
 */
import { Map } from 'immutable'
import { getUserLanguagePrimary } from '../user/index'
import { GET_PM_LIST } from './actions'
import getPmList from './watchers-helpers'

/**
 * Handle get PM List action
 */
// eslint-disable-next-line import/prefer-default-export
export function onGetPmList ({ after }) {
  return after(GET_PM_LIST, async ({ dispatch, state, action }) => {
    const {
      auth = Map(),
      user = Map(),
      pmList = Map(),
    } = state
    const {
      payload: {
        listId,
        language = getUserLanguagePrimary(user),
      } = {},
    } = action

    await getPmList({
      dispatch,
      language,
      auth,
      pmList,
      listId,
    })
  })
}
